import { render, staticRenderFns } from "./TabLazy.vue?vue&type=template&id=6522e9db&"
import script from "./TabLazy.vue?vue&type=script&lang=js&"
export * from "./TabLazy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports